import { useGetCmUsersQuery } from "../../core/api/cm-user-api"
import { DataGrid } from "@mui/x-data-grid"
import dayjs from "dayjs"

const columns = [
    {
        field: "id",
        headerName: "ID",
        flex: 1
    },
    {
        field: "userId",
        headerName: "User ID",
        flex: 1
    },
    {
        field: "socialId",
        headerName: "Social ID",
        flex: 1,
        valueGetter: (value) => value ? value : "-"
    },
    {
        field: "facebookId",
        headerName: "FB ID",
        flex: 1,
        valueGetter: (value) => value ? value : "-"
    },
    {
        field: "syncId",
        headerName: "Sync ID",
        flex: 1,
        valueGetter: (value) => value ? value : "-"
    },
    {
        field: "platform",
        headerName: "Platform",
        flex: 1
    },
    {
        field: "version",
        headerName: "Version",
        flex: 1,
        valueGetter: (value) => value ? value : "-"
    },
    {
        field: "timestamp",
        headerName: "Timestamp",
        flex: 1,
        valueGetter: (value) => value ? dayjs(value).format("DD.MM.YYYY HH:mm:ss.SSS") : "-"
    }
]

const CmUserConnections = ({ deviceId, depth }) => {
    const {
        data,
        isLoading,
        isFetching
    } = useGetCmUsersQuery({
        "userId": deviceId,
        "depth": depth
    }, {
        skip: !deviceId || deviceId.trim() === ""
    })

    return (
        <DataGrid
            hideFooter
            columns={columns}
            rows={data ?? []}
            rowCount={-1}
            loading={isLoading || isFetching}
        />
    )
}

export default CmUserConnections
